import { ResponseException } from "../../../../Exceptions";
import { request } from "../../api";

export async function getSamedayAccountStatus() {
    const response = await request("/data/sameday/status/account");
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getSamedayProvinceStatus({ province, month, year }) {
    const response = await request("/data/sameday/status/province", { query: { province, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getSamedayLGUStatus({ lgu, month, year }) {
    const response = await request("/data/sameday/status/lgu", { query: { lgu, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}





export async function getSamedayPending() {
    const response = await request("/data/sameday/status/pending");
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getSamedayReturned() {
    const response = await request("/data/sameday/status/returned");
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getSamedayPublished({ province, lgu, month, year, offset = 0, limit = 100 }) {
    const response = await request("/data/sameday/status/published", { query: { province, lgu, month, year, offset, limit } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}
